export default "__VITE_ASSET__5fbb2a8b__"